import { Link } from 'react-router-dom';
import { MessageToolPage } from '@/components/seo/MessageToolPage';

export default function HeartfeltMessageGenerator() {
  return (
    <MessageToolPage
      title="Heartfelt Message Generator — Free AI Writing Tool"
      metaDescription="Generate a heartfelt message for someone you love — free. Our AI tool helps you find the right words for parents, partners, friends, and more."
      h1="Free Heartfelt Message Generator"
      subtitle="Struggling to find the right words? Let our AI help you express what matters most."
      toolLabel="Generate a Heartfelt Message"
      placeholder="e.g. I want to thank her for always being there during hard times..."
      systemPrompt="Write a heartfelt, emotionally resonant message of love and appreciation. Be warm, specific, and genuine. Avoid clichés. The tone should be calm, human, and unhurried."
      faq={[
        { q: 'Is this tool really free?', a: 'Yes. You can generate heartfelt messages at no cost. For a more polished experience with templates, photos, and permanent links, create a free account on Say It NOW.' },
        { q: 'Will my message sound generic?', a: 'No. The AI uses the context you provide — the name, relationship, and details — to craft a personalized message. The more detail you provide, the more personal the result.' },
        { q: 'Can I edit the generated message?', a: 'Absolutely. The generated message is a starting point. Copy it and customize it however you like, or use it as-is within a Say It NOW Living Announcement.' },
        { q: 'What relationships does this work for?', a: 'Any relationship — parents, partners, friends, siblings, mentors, colleagues, or anyone who has touched your life.' },
      ]}
      relatedPages={[
        { label: 'Heartfelt Message to Mom', href: '/heartfelt-message-to-mom' },
        { label: 'Heartfelt Message to Dad', href: '/heartfelt-message-to-dad' },
        { label: 'Message to Someone You Love', href: '/message-to-someone-you-love' },
        { label: 'Thank You Message Generator', href: '/tools/thank-you-message-generator' },
        { label: 'Apology Message Generator', href: '/tools/apology-message-generator' },
      ]}
      seoContent={
        <>
          <h2>Why Use a Heartfelt Message Generator?</h2>
          <p>
            We all have people we love but struggle to express it to. Whether it's a parent who sacrificed everything, a partner who stands by you, or a friend who showed up when no one else did — the feelings are there, but the words often aren't.
          </p>
          <p>
            This free <strong>heartfelt message creator</strong> uses AI to help you break through the blank page. Just tell us who you're writing to, your relationship, and a bit of context — and we'll generate a genuine, emotional message you can use, edit, or draw inspiration from.
          </p>
          <h2>How It Works</h2>
          <ol>
            <li><strong>Enter a name</strong> — who is this message for?</li>
            <li><strong>Choose the relationship</strong> — parent, partner, friend, sibling, or mentor.</li>
            <li><strong>Add context</strong> — what do you want to express? A thank you, a memory, a feeling?</li>
            <li><strong>Generate</strong> — our AI crafts a personalized message in seconds.</li>
          </ol>
          <p>
            Want to make it even more special? <Link to="/signup">Create a free Say It NOW account</Link> to turn your message into a beautiful Living Announcement with templates, photos, and reveal animations.
          </p>
        </>
      }
    />
  );
}
